import { render, staticRenderFns } from "./ActiveGames.vue?vue&type=template&id=2d0a784c&scoped=true&"
import script from "./ActiveGames.vue?vue&type=script&lang=js&"
export * from "./ActiveGames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0a784c",
  null
  
)

export default component.exports